import styled from 'styled-components';

import { Color, FontWeight } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { MenuPosition } from '../../menuPosition/menuPosition.component';

import { ContainerProps } from './tabUnderline.types';

export const Container: StyledComponent<typeof MenuPosition, ContainerProps> = styled(MenuPosition)<ContainerProps>`
  display: flex;
  align-items: center;
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 25px 0;
  color: ${({ $isActive }: ContainerProps): Color => $isActive ? Color.Black : Color.Gray500};
  border-bottom: 1px solid ${({ $isActive, $withTransparentUnderline }: ContainerProps): string => $withTransparentUnderline
    ? Color.Transparent
    : $isActive
      ? Color.Error500
      : Color.Gray500
};
`;

export const Counter: StyledComponent<'div'> = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${Color.White};
  font-weight: ${FontWeight.Bold};
  color: ${Color.Error500};
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 8px;
`;
